import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TabItem } from 'src/app/core/interfaces/tab-item.interface';

@Component({
  selector: 'app-tab-router',
  templateUrl: './tab-router.component.html',
  styleUrl: './tab-router.component.scss'
})
export class TabRouterComponent {
  @Input({ required: true }) items: TabItem[];

  constructor(private router: Router) {}

  isActive(item: TabItem): boolean {
    // If activeStateLinks is provided for this item, use it to determine active state
    if (item.activeStateLinks && item.activeStateLinks.length > 0) {
      const currentUrl = this.router.url;
      return item.activeStateLinks.some(activeLink => currentUrl.includes(activeLink));
    }
    
    // Otherwise, use the default behavior with the item's link
    const currentUrl = this.router.url;
    return currentUrl.includes(item.link);
  }
}
